import * as i0 from '@angular/core';
import { forwardRef, Directive, NgModule } from '@angular/core';
import { NG_VALIDATORS } from '@angular/forms';

class IbanValidator {
    constructor() {
    }
    static validate(control) {
        if (!control.value) {
            return null;
        }
        if (!isValidIBANNumber(control.value)) {
            return { invalidIBAN: true };
        }
        return null;
    }
    validate(control) {
        if (!control.value) {
            return null;
        }
        return !isValidIBANNumber(control.value) ? { invalidIBAN: { value: control.value } } : null;
    }
    static { this.ɵfac = function IbanValidator_Factory(t) { return new (t || IbanValidator)(); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: IbanValidator, selectors: [["", "iban", "", "ngModel", ""]], features: [i0.ɵɵProvidersFeature([{ provide: NG_VALIDATORS, useExisting: forwardRef(() => IbanValidator), multi: true }])] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IbanValidator, [{
        type: Directive,
        args: [{
                selector: '[iban][ngModel]',
                providers: [{ provide: NG_VALIDATORS, useExisting: forwardRef(() => IbanValidator), multi: true }]
            }]
    }], function () { return []; }, null); })();
const mod97 = (digits) => {
    let checksum = digits.slice(0, 2);
    let fragment;
    for (let offset = 2; offset < digits.length; offset += 7) {
        fragment = String(checksum) + digits.substring(offset, offset + 7);
        checksum = parseInt(fragment, 10) % 97;
    }
    return checksum === 1;
};
const isValidIBANNumber = (input) => {
    const ibanCountryCodeLength = {
        AD: 24,
        AE: 23,
        AT: 20,
        AZ: 28,
        BA: 20,
        BE: 16,
        BG: 22,
        BH: 22,
        BR: 29,
        CH: 21,
        CR: 21,
        CY: 28,
        CZ: 24,
        DE: 22,
        DK: 18,
        DO: 28,
        EE: 20,
        ES: 24,
        FI: 18,
        FO: 18,
        FR: 27,
        GB: 22,
        GI: 23,
        GL: 18,
        GR: 27,
        GT: 28,
        HR: 21,
        HU: 28,
        IE: 22,
        IL: 23,
        IS: 26,
        IT: 27,
        JO: 30,
        KW: 30,
        KZ: 20,
        LB: 28,
        LI: 21,
        LT: 20,
        LU: 20,
        LV: 21,
        MC: 27,
        MD: 24,
        ME: 22,
        MK: 19,
        MR: 27,
        MT: 31,
        MU: 30,
        NL: 18,
        NO: 15,
        PK: 24,
        PL: 28,
        PS: 29,
        PT: 25,
        QA: 29,
        RO: 24,
        RS: 22,
        SA: 24,
        SE: 24,
        SI: 19,
        SK: 24,
        SM: 27,
        TN: 24,
        TR: 26,
    };
    const iban = String(input)
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, ''); // keep only alphanumeric characters
    // Match and capture (1) the country code, (2) the check digits, and (3) the rest
    const matches = iban.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/);
    if (matches === null) {
        return false;
    }
    const [value, countryCode, checkDigits, accountNumber] = matches;
    // Check syntax and length
    if (!countryCode || iban.length !== ibanCountryCodeLength[countryCode]) {
        return false;
    }
    // Rearrange country code and check digits, and convert chars to numbers.
    const digits = (accountNumber + countryCode + checkDigits).replace(/[A-Z]/g, (char) => (char.charCodeAt(0) - 55).toString());
    return mod97(digits);
};

class VatValidator {
    constructor() { }
    static validate(control) {
        if (!control.value) {
            return null;
        }
        if (!isVatNumber(control.value)) {
            return { invalidVAT: true };
        }
        return null;
    }
    validate(control) {
        if (!control.value) {
            return null;
        }
        return !isVatNumber(control.value)
            ? { invalidVAT: { value: control.value } }
            : null;
    }
    static { this.ɵfac = function VatValidator_Factory(t) { return new (t || VatValidator)(); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: VatValidator, selectors: [["", "vat", "", "ngModel", ""]], features: [i0.ɵɵProvidersFeature([
                {
                    provide: NG_VALIDATORS,
                    useExisting: forwardRef(() => VatValidator),
                    multi: true,
                },
            ])] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VatValidator, [{
        type: Directive,
        args: [{
                selector: '[vat][ngModel]',
                providers: [
                    {
                        provide: NG_VALIDATORS,
                        useExisting: forwardRef(() => VatValidator),
                        multi: true,
                    },
                ],
            }]
    }], function () { return []; }, null); })();
const normalizeVATNumber = (input = '') => input.replace(/[^0-9A-Za-z]/g, '').toUpperCase();
const isVatNumber = (input) => {
    const vatNumber = normalizeVATNumber(input);
    return /^(BE)?0[0-9]{9}$/.test(vatNumber);
};

class PhoneValidator {
    constructor() { }
    static validate(control) {
        if (!control.value) {
            return null;
        }
        if (!isPhoneNumber(control.value)) {
            return { invalidPhone: true };
        }
        return null;
    }
    validate(control) {
        if (!control.value) {
            return null;
        }
        return !isPhoneNumber(control.value)
            ? { invalidPhone: { value: control.value } }
            : null;
    }
    static { this.ɵfac = function PhoneValidator_Factory(t) { return new (t || PhoneValidator)(); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: PhoneValidator, selectors: [["", "phone", "", "ngModel", ""]], features: [i0.ɵɵProvidersFeature([
                {
                    provide: NG_VALIDATORS,
                    useExisting: forwardRef(() => PhoneValidator),
                    multi: true,
                },
            ])] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PhoneValidator, [{
        type: Directive,
        args: [{
                selector: '[phone][ngModel]',
                providers: [
                    {
                        provide: NG_VALIDATORS,
                        useExisting: forwardRef(() => PhoneValidator),
                        multi: true,
                    },
                ],
            }]
    }], function () { return []; }, null); })();
const normalizePhoneNumber = (input = '') => input.replace(/[^\d+]+/g, '');
const isPhoneNumber = (input) => 
// eslint-disable-next-line max-len
/^(((\+|00)32[ ]?(?:\(0\)[ ]?)?)|0){1}(4(60|[789]\d)\/?(\s?\d{2}\.?){2}(\s?\d{2})|(\d\/?\s?\d{3}|\d{2}\/?\s?\d{2})(\.?\s?\d{2}){2})$/.test(input);

class EmailValidator {
    constructor() { }
    static validate(control) {
        if (!control.value) {
            return null;
        }
        if (!isEmail(control.value)) {
            return { invalidPhone: true };
        }
        return null;
    }
    validate(control) {
        if (!control.value) {
            return null;
        }
        return !isEmail(control.value)
            ? { invalidEmail: { value: control.value } }
            : null;
    }
    static { this.ɵfac = function EmailValidator_Factory(t) { return new (t || EmailValidator)(); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: EmailValidator, selectors: [["", "email", "", "ngModel", ""]], features: [i0.ɵɵProvidersFeature([
                {
                    provide: NG_VALIDATORS,
                    useExisting: forwardRef(() => EmailValidator),
                    multi: true,
                },
            ])] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EmailValidator, [{
        type: Directive,
        args: [{
                selector: '[email][ngModel]',
                providers: [
                    {
                        provide: NG_VALIDATORS,
                        useExisting: forwardRef(() => EmailValidator),
                        multi: true,
                    },
                ],
            }]
    }], function () { return []; }, null); })();
const isEmail = (input) => /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,8}$/.test(input);

class EanValidator {
    constructor() { }
    static validate(control) {
        if (!control.value) {
            return null;
        }
        if (!isValidEANNumber(control.value)) {
            return { invalidEAN: true };
        }
        return null;
    }
    validate(control) {
        if (!control.value) {
            return null;
        }
        return !isValidEANNumber(control.value)
            ? { invalidEAN: { value: control.value } }
            : null;
    }
    static { this.ɵfac = function EanValidator_Factory(t) { return new (t || EanValidator)(); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: EanValidator, selectors: [["", "ean", "", "ngModel", ""]], features: [i0.ɵɵProvidersFeature([
                {
                    provide: NG_VALIDATORS,
                    useExisting: forwardRef(() => EanValidator),
                    multi: true,
                },
            ])] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EanValidator, [{
        type: Directive,
        args: [{
                selector: '[ean][ngModel]',
                providers: [
                    {
                        provide: NG_VALIDATORS,
                        useExisting: forwardRef(() => EanValidator),
                        multi: true,
                    },
                ],
            }]
    }], function () { return []; }, null); })();
const isValidEANNumber = (input) => {
    if (!input) {
        return null;
    }
    // Strip spaces.
    input = input.replace(/\s/g, '');
    // Check if we have 18 digits.
    if (!/^[0-9]{18}$/.test(input)) {
        return false;
    }
    // Make sure the eans start with 5414 or 5414
    if (!['5414', '5425'].includes(input.substring(0, 4))) {
        return false;
    }
    // Check the checkSum.
    let sum = 0;
    let checkSum = +input.slice(-1);
    let calcCheckSum = 0;
    input.split('').map((number, index) => {
        if (index === input.length) {
            return;
        }
        sum += +number * (index % 2 === 1 ? 1 : 3);
    });
    sum -= checkSum;
    sum %= 10;
    calcCheckSum = sum === 0 ? 0 : 10 - sum;
    return calcCheckSum === checkSum;
};

class ValidatorsModule {
    static { this.ɵfac = function ValidatorsModule_Factory(t) { return new (t || ValidatorsModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ValidatorsModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({}); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ValidatorsModule, [{
        type: NgModule,
        args: [{
                declarations: [IbanValidator, VatValidator, PhoneValidator, EmailValidator, EanValidator],
                imports: [],
                exports: [IbanValidator, VatValidator, PhoneValidator, EmailValidator],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ValidatorsModule, { declarations: [IbanValidator, VatValidator, PhoneValidator, EmailValidator, EanValidator], exports: [IbanValidator, VatValidator, PhoneValidator, EmailValidator] }); })();

/*
 * Public API Surface of validators
 */

/**
 * Generated bundle index. Do not edit.
 */

export { EanValidator, EmailValidator, IbanValidator, PhoneValidator, ValidatorsModule, VatValidator, isEmail, isPhoneNumber, isValidEANNumber, isValidIBANNumber, isVatNumber, normalizePhoneNumber, normalizeVATNumber };
